import { render } from "./EntraPageHeader.vue?vue&type=template&id=8270290c&scoped=true"
import script from "./EntraPageHeader.vue?vue&type=script&lang=js"
export * from "./EntraPageHeader.vue?vue&type=script&lang=js"

import "./EntraPageHeader.vue?vue&type=style&index=0&id=8270290c&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8270290c"]])

export default __exports__